import { __decorate, __metadata, __param } from 'tslib';
import { SkipSelf, Host, Input, Component, NgModule } from '@angular/core';
import { NestedOption, NestedOptionHost } from 'devextreme-angular/core';

/* tslint:disable:max-line-length */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'devextreme-angular/core';
let DxoAjaxRemoteServiceComponent = class DxoAjaxRemoteServiceComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get beforeSend() {
        return this._getOption('beforeSend');
    }
    set beforeSend(value) {
        this._setOption('beforeSend', value);
    }
    get complete() {
        return this._getOption('complete');
    }
    set complete(value) {
        this._setOption('complete', value);
    }
    get headers() {
        return this._getOption('headers');
    }
    set headers(value) {
        this._setOption('headers', value);
    }
    get _optionPath() {
        return 'ajaxRemoteService';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoAjaxRemoteServiceComponent.ɵfac = function DxoAjaxRemoteServiceComponent_Factory(t) { return new (t || DxoAjaxRemoteServiceComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoAjaxRemoteServiceComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoAjaxRemoteServiceComponent, selectors: [["dxo-ajax-remote-service"]], inputs: { beforeSend: "beforeSend", complete: "complete", headers: "headers" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoAjaxRemoteServiceComponent_Template(rf, ctx) { }, styles: [""] });
DxoAjaxRemoteServiceComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoAjaxRemoteServiceComponent.prototype, "beforeSend", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoAjaxRemoteServiceComponent.prototype, "complete", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DxoAjaxRemoteServiceComponent.prototype, "headers", null);
DxoAjaxRemoteServiceComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoAjaxRemoteServiceComponent);
let DxoAjaxRemoteServiceModule = class DxoAjaxRemoteServiceModule {
};
DxoAjaxRemoteServiceModule.ɵfac = function DxoAjaxRemoteServiceModule_Factory(t) { return new (t || DxoAjaxRemoteServiceModule)(); };
DxoAjaxRemoteServiceModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoAjaxRemoteServiceModule });
DxoAjaxRemoteServiceModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
let DxoDashboardExportComponent = class DxoDashboardExportComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get allowExportDashboard() {
        return this._getOption('allowExportDashboard');
    }
    set allowExportDashboard(value) {
        this._setOption('allowExportDashboard', value);
    }
    get allowExportDashboardItems() {
        return this._getOption('allowExportDashboardItems');
    }
    set allowExportDashboardItems(value) {
        this._setOption('allowExportDashboardItems', value);
    }
    get onExportDialogHidden() {
        return this._getOption('onExportDialogHidden');
    }
    set onExportDialogHidden(value) {
        this._setOption('onExportDialogHidden', value);
    }
    get onExportDialogShowing() {
        return this._getOption('onExportDialogShowing');
    }
    set onExportDialogShowing(value) {
        this._setOption('onExportDialogShowing', value);
    }
    get onExportDialogShown() {
        return this._getOption('onExportDialogShown');
    }
    set onExportDialogShown(value) {
        this._setOption('onExportDialogShown', value);
    }
    get _optionPath() {
        return 'dashboardExport';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoDashboardExportComponent.ɵfac = function DxoDashboardExportComponent_Factory(t) { return new (t || DxoDashboardExportComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoDashboardExportComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoDashboardExportComponent, selectors: [["dxo-dashboard-export"]], inputs: { allowExportDashboard: "allowExportDashboard", allowExportDashboardItems: "allowExportDashboardItems", onExportDialogHidden: "onExportDialogHidden", onExportDialogShowing: "onExportDialogShowing", onExportDialogShown: "onExportDialogShown" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoDashboardExportComponent_Template(rf, ctx) { }, styles: [""] });
DxoDashboardExportComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], DxoDashboardExportComponent.prototype, "allowExportDashboard", null);
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], DxoDashboardExportComponent.prototype, "allowExportDashboardItems", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDashboardExportComponent.prototype, "onExportDialogHidden", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDashboardExportComponent.prototype, "onExportDialogShowing", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDashboardExportComponent.prototype, "onExportDialogShown", null);
DxoDashboardExportComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoDashboardExportComponent);
let DxoDashboardExportModule = class DxoDashboardExportModule {
};
DxoDashboardExportModule.ɵfac = function DxoDashboardExportModule_Factory(t) { return new (t || DxoDashboardExportModule)(); };
DxoDashboardExportModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoDashboardExportModule });
DxoDashboardExportModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
let DxoDashboardParameterDialogComponent = class DxoDashboardParameterDialogComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get onDynamicLookUpValuesLoaded() {
        return this._getOption('onDynamicLookUpValuesLoaded');
    }
    set onDynamicLookUpValuesLoaded(value) {
        this._setOption('onDynamicLookUpValuesLoaded', value);
    }
    get onHidden() {
        return this._getOption('onHidden');
    }
    set onHidden(value) {
        this._setOption('onHidden', value);
    }
    get onShowing() {
        return this._getOption('onShowing');
    }
    set onShowing(value) {
        this._setOption('onShowing', value);
    }
    get onShown() {
        return this._getOption('onShown');
    }
    set onShown(value) {
        this._setOption('onShown', value);
    }
    get _optionPath() {
        return 'dashboardParameterDialog';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoDashboardParameterDialogComponent.ɵfac = function DxoDashboardParameterDialogComponent_Factory(t) { return new (t || DxoDashboardParameterDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoDashboardParameterDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoDashboardParameterDialogComponent, selectors: [["dxo-dashboard-parameter-dialog"]], inputs: { onDynamicLookUpValuesLoaded: "onDynamicLookUpValuesLoaded", onHidden: "onHidden", onShowing: "onShowing", onShown: "onShown" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoDashboardParameterDialogComponent_Template(rf, ctx) { }, styles: [""] });
DxoDashboardParameterDialogComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDashboardParameterDialogComponent.prototype, "onDynamicLookUpValuesLoaded", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDashboardParameterDialogComponent.prototype, "onHidden", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDashboardParameterDialogComponent.prototype, "onShowing", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDashboardParameterDialogComponent.prototype, "onShown", null);
DxoDashboardParameterDialogComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoDashboardParameterDialogComponent);
let DxoDashboardParameterDialogModule = class DxoDashboardParameterDialogModule {
};
DxoDashboardParameterDialogModule.ɵfac = function DxoDashboardParameterDialogModule_Factory(t) { return new (t || DxoDashboardParameterDialogModule)(); };
DxoDashboardParameterDialogModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoDashboardParameterDialogModule });
DxoDashboardParameterDialogModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
let DxoDataInspectorComponent = class DxoDataInspectorComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get allowInspectAggregatedData() {
        return this._getOption('allowInspectAggregatedData');
    }
    set allowInspectAggregatedData(value) {
        this._setOption('allowInspectAggregatedData', value);
    }
    get allowInspectRawData() {
        return this._getOption('allowInspectRawData');
    }
    set allowInspectRawData(value) {
        this._setOption('allowInspectRawData', value);
    }
    get onDialogHidden() {
        return this._getOption('onDialogHidden');
    }
    set onDialogHidden(value) {
        this._setOption('onDialogHidden', value);
    }
    get onDialogShowing() {
        return this._getOption('onDialogShowing');
    }
    set onDialogShowing(value) {
        this._setOption('onDialogShowing', value);
    }
    get onDialogShown() {
        return this._getOption('onDialogShown');
    }
    set onDialogShown(value) {
        this._setOption('onDialogShown', value);
    }
    get onGridContentReady() {
        return this._getOption('onGridContentReady');
    }
    set onGridContentReady(value) {
        this._setOption('onGridContentReady', value);
    }
    get onGridInitialized() {
        return this._getOption('onGridInitialized');
    }
    set onGridInitialized(value) {
        this._setOption('onGridInitialized', value);
    }
    get _optionPath() {
        return 'dataInspector';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoDataInspectorComponent.ɵfac = function DxoDataInspectorComponent_Factory(t) { return new (t || DxoDataInspectorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoDataInspectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoDataInspectorComponent, selectors: [["dxo-data-inspector"]], inputs: { allowInspectAggregatedData: "allowInspectAggregatedData", allowInspectRawData: "allowInspectRawData", onDialogHidden: "onDialogHidden", onDialogShowing: "onDialogShowing", onDialogShown: "onDialogShown", onGridContentReady: "onGridContentReady", onGridInitialized: "onGridInitialized" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoDataInspectorComponent_Template(rf, ctx) { }, styles: [""] });
DxoDataInspectorComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], DxoDataInspectorComponent.prototype, "allowInspectAggregatedData", null);
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], DxoDataInspectorComponent.prototype, "allowInspectRawData", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDataInspectorComponent.prototype, "onDialogHidden", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDataInspectorComponent.prototype, "onDialogShowing", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDataInspectorComponent.prototype, "onDialogShown", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDataInspectorComponent.prototype, "onGridContentReady", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDataInspectorComponent.prototype, "onGridInitialized", null);
DxoDataInspectorComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoDataInspectorComponent);
let DxoDataInspectorModule = class DxoDataInspectorModule {
};
DxoDataInspectorModule.ɵfac = function DxoDataInspectorModule_Factory(t) { return new (t || DxoDataInspectorModule)(); };
DxoDataInspectorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoDataInspectorModule });
DxoDataInspectorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
let DxoDataRequestOptionsComponent = class DxoDataRequestOptionsComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get itemDataLoadingMode() {
        return this._getOption('itemDataLoadingMode');
    }
    set itemDataLoadingMode(value) {
        this._setOption('itemDataLoadingMode', value);
    }
    get itemDataRequestMode() {
        return this._getOption('itemDataRequestMode');
    }
    set itemDataRequestMode(value) {
        this._setOption('itemDataRequestMode', value);
    }
    get _optionPath() {
        return 'dataRequestOptions';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoDataRequestOptionsComponent.ɵfac = function DxoDataRequestOptionsComponent_Factory(t) { return new (t || DxoDataRequestOptionsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoDataRequestOptionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoDataRequestOptionsComponent, selectors: [["dxo-data-request-options"]], inputs: { itemDataLoadingMode: "itemDataLoadingMode", itemDataRequestMode: "itemDataRequestMode" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoDataRequestOptionsComponent_Template(rf, ctx) { }, styles: [""] });
DxoDataRequestOptionsComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], DxoDataRequestOptionsComponent.prototype, "itemDataLoadingMode", null);
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], DxoDataRequestOptionsComponent.prototype, "itemDataRequestMode", null);
DxoDataRequestOptionsComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoDataRequestOptionsComponent);
let DxoDataRequestOptionsModule = class DxoDataRequestOptionsModule {
};
DxoDataRequestOptionsModule.ɵfac = function DxoDataRequestOptionsModule_Factory(t) { return new (t || DxoDataRequestOptionsModule)(); };
DxoDataRequestOptionsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoDataRequestOptionsModule });
DxoDataRequestOptionsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
let DxoDataSourceWizardComponent = class DxoDataSourceWizardComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get allowCreateNewJsonConnection() {
        return this._getOption('allowCreateNewJsonConnection');
    }
    set allowCreateNewJsonConnection(value) {
        this._setOption('allowCreateNewJsonConnection', value);
    }
    get enableCustomSql() {
        return this._getOption('enableCustomSql');
    }
    set enableCustomSql(value) {
        this._setOption('enableCustomSql', value);
    }
    get onCustomizeDataSourceWizard() {
        return this._getOption('onCustomizeDataSourceWizard');
    }
    set onCustomizeDataSourceWizard(value) {
        this._setOption('onCustomizeDataSourceWizard', value);
    }
    get wizardSettings() {
        return this._getOption('wizardSettings');
    }
    set wizardSettings(value) {
        this._setOption('wizardSettings', value);
    }
    get _optionPath() {
        return 'dataSourceWizard';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoDataSourceWizardComponent.ɵfac = function DxoDataSourceWizardComponent_Factory(t) { return new (t || DxoDataSourceWizardComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoDataSourceWizardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoDataSourceWizardComponent, selectors: [["dxo-data-source-wizard"]], inputs: { allowCreateNewJsonConnection: "allowCreateNewJsonConnection", enableCustomSql: "enableCustomSql", onCustomizeDataSourceWizard: "onCustomizeDataSourceWizard", wizardSettings: "wizardSettings" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoDataSourceWizardComponent_Template(rf, ctx) { }, styles: [""] });
DxoDataSourceWizardComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], DxoDataSourceWizardComponent.prototype, "allowCreateNewJsonConnection", null);
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], DxoDataSourceWizardComponent.prototype, "enableCustomSql", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoDataSourceWizardComponent.prototype, "onCustomizeDataSourceWizard", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DxoDataSourceWizardComponent.prototype, "wizardSettings", null);
DxoDataSourceWizardComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoDataSourceWizardComponent);
let DxoDataSourceWizardModule = class DxoDataSourceWizardModule {
};
DxoDataSourceWizardModule.ɵfac = function DxoDataSourceWizardModule_Factory(t) { return new (t || DxoDataSourceWizardModule)(); };
DxoDataSourceWizardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoDataSourceWizardModule });
DxoDataSourceWizardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
let DxoExtensionsComponent = class DxoExtensionsComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get dashboardExport() {
        return this._getOption('dashboardExport');
    }
    set dashboardExport(value) {
        this._setOption('dashboardExport', value);
    }
    get dashboardParameterDialog() {
        return this._getOption('dashboardParameterDialog');
    }
    set dashboardParameterDialog(value) {
        this._setOption('dashboardParameterDialog', value);
    }
    get dataInspector() {
        return this._getOption('dataInspector');
    }
    set dataInspector(value) {
        this._setOption('dataInspector', value);
    }
    get dataSourceWizard() {
        return this._getOption('dataSourceWizard');
    }
    set dataSourceWizard(value) {
        this._setOption('dataSourceWizard', value);
    }
    get itemBindingPanel() {
        return this._getOption('itemBindingPanel');
    }
    set itemBindingPanel(value) {
        this._setOption('itemBindingPanel', value);
    }
    get itemOptionsPanel() {
        return this._getOption('itemOptionsPanel');
    }
    set itemOptionsPanel(value) {
        this._setOption('itemOptionsPanel', value);
    }
    get mobileLayout() {
        return this._getOption('mobileLayout');
    }
    set mobileLayout(value) {
        this._setOption('mobileLayout', value);
    }
    get viewerApi() {
        return this._getOption('viewerApi');
    }
    set viewerApi(value) {
        this._setOption('viewerApi', value);
    }
    get _optionPath() {
        return 'extensions';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoExtensionsComponent.ɵfac = function DxoExtensionsComponent_Factory(t) { return new (t || DxoExtensionsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoExtensionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoExtensionsComponent, selectors: [["dxo-extensions"]], inputs: { dashboardExport: "dashboardExport", dashboardParameterDialog: "dashboardParameterDialog", dataInspector: "dataInspector", dataSourceWizard: "dataSourceWizard", itemBindingPanel: "itemBindingPanel", itemOptionsPanel: "itemOptionsPanel", mobileLayout: "mobileLayout", viewerApi: "viewerApi" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoExtensionsComponent_Template(rf, ctx) { }, styles: [""] });
DxoExtensionsComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DxoExtensionsComponent.prototype, "dashboardExport", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DxoExtensionsComponent.prototype, "dashboardParameterDialog", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DxoExtensionsComponent.prototype, "dataInspector", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DxoExtensionsComponent.prototype, "dataSourceWizard", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DxoExtensionsComponent.prototype, "itemBindingPanel", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DxoExtensionsComponent.prototype, "itemOptionsPanel", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DxoExtensionsComponent.prototype, "mobileLayout", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DxoExtensionsComponent.prototype, "viewerApi", null);
DxoExtensionsComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoExtensionsComponent);
let DxoExtensionsModule = class DxoExtensionsModule {
};
DxoExtensionsModule.ɵfac = function DxoExtensionsModule_Factory(t) { return new (t || DxoExtensionsModule)(); };
DxoExtensionsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoExtensionsModule });
DxoExtensionsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
let DxoItemBindingPanelComponent = class DxoItemBindingPanelComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get onCustomizeDataItemContainerSections() {
        return this._getOption('onCustomizeDataItemContainerSections');
    }
    set onCustomizeDataItemContainerSections(value) {
        this._setOption('onCustomizeDataItemContainerSections', value);
    }
    get _optionPath() {
        return 'itemBindingPanel';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoItemBindingPanelComponent.ɵfac = function DxoItemBindingPanelComponent_Factory(t) { return new (t || DxoItemBindingPanelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoItemBindingPanelComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoItemBindingPanelComponent, selectors: [["dxo-item-binding-panel"]], inputs: { onCustomizeDataItemContainerSections: "onCustomizeDataItemContainerSections" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoItemBindingPanelComponent_Template(rf, ctx) { }, styles: [""] });
DxoItemBindingPanelComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoItemBindingPanelComponent.prototype, "onCustomizeDataItemContainerSections", null);
DxoItemBindingPanelComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoItemBindingPanelComponent);
let DxoItemBindingPanelModule = class DxoItemBindingPanelModule {
};
DxoItemBindingPanelModule.ɵfac = function DxoItemBindingPanelModule_Factory(t) { return new (t || DxoItemBindingPanelModule)(); };
DxoItemBindingPanelModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoItemBindingPanelModule });
DxoItemBindingPanelModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
let DxoItemOptionsPanelComponent = class DxoItemOptionsPanelComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get onCustomizeSections() {
        return this._getOption('onCustomizeSections');
    }
    set onCustomizeSections(value) {
        this._setOption('onCustomizeSections', value);
    }
    get _optionPath() {
        return 'itemOptionsPanel';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoItemOptionsPanelComponent.ɵfac = function DxoItemOptionsPanelComponent_Factory(t) { return new (t || DxoItemOptionsPanelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoItemOptionsPanelComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoItemOptionsPanelComponent, selectors: [["dxo-item-options-panel"]], inputs: { onCustomizeSections: "onCustomizeSections" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoItemOptionsPanelComponent_Template(rf, ctx) { }, styles: [""] });
DxoItemOptionsPanelComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoItemOptionsPanelComponent.prototype, "onCustomizeSections", null);
DxoItemOptionsPanelComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoItemOptionsPanelComponent);
let DxoItemOptionsPanelModule = class DxoItemOptionsPanelModule {
};
DxoItemOptionsPanelModule.ɵfac = function DxoItemOptionsPanelModule_Factory(t) { return new (t || DxoItemOptionsPanelModule)(); };
DxoItemOptionsPanelModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoItemOptionsPanelModule });
DxoItemOptionsPanelModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
let DxoMobileLayoutComponent = class DxoMobileLayoutComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get mobileLayoutEnabled() {
        return this._getOption('mobileLayoutEnabled');
    }
    set mobileLayoutEnabled(value) {
        this._setOption('mobileLayoutEnabled', value);
    }
    get _optionPath() {
        return 'mobileLayout';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoMobileLayoutComponent.ɵfac = function DxoMobileLayoutComponent_Factory(t) { return new (t || DxoMobileLayoutComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoMobileLayoutComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoMobileLayoutComponent, selectors: [["dxo-mobile-layout"]], inputs: { mobileLayoutEnabled: "mobileLayoutEnabled" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoMobileLayoutComponent_Template(rf, ctx) { }, styles: [""] });
DxoMobileLayoutComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], DxoMobileLayoutComponent.prototype, "mobileLayoutEnabled", null);
DxoMobileLayoutComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoMobileLayoutComponent);
let DxoMobileLayoutModule = class DxoMobileLayoutModule {
};
DxoMobileLayoutModule.ɵfac = function DxoMobileLayoutModule_Factory(t) { return new (t || DxoMobileLayoutModule)(); };
DxoMobileLayoutModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoMobileLayoutModule });
DxoMobileLayoutModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
let DxoViewerApiComponent = class DxoViewerApiComponent extends NestedOption {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get onDashboardTitleToolbarUpdated() {
        return this._getOption('onDashboardTitleToolbarUpdated');
    }
    set onDashboardTitleToolbarUpdated(value) {
        this._setOption('onDashboardTitleToolbarUpdated', value);
    }
    get onItemActionAvailabilityChanged() {
        return this._getOption('onItemActionAvailabilityChanged');
    }
    set onItemActionAvailabilityChanged(value) {
        this._setOption('onItemActionAvailabilityChanged', value);
    }
    get onItemCaptionToolbarUpdated() {
        return this._getOption('onItemCaptionToolbarUpdated');
    }
    set onItemCaptionToolbarUpdated(value) {
        this._setOption('onItemCaptionToolbarUpdated', value);
    }
    get onItemClick() {
        return this._getOption('onItemClick');
    }
    set onItemClick(value) {
        this._setOption('onItemClick', value);
    }
    get onItemDrillDownStateChanged() {
        return this._getOption('onItemDrillDownStateChanged');
    }
    set onItemDrillDownStateChanged(value) {
        this._setOption('onItemDrillDownStateChanged', value);
    }
    get onItemElementCustomColor() {
        return this._getOption('onItemElementCustomColor');
    }
    set onItemElementCustomColor(value) {
        this._setOption('onItemElementCustomColor', value);
    }
    get onItemMasterFilterStateChanged() {
        return this._getOption('onItemMasterFilterStateChanged');
    }
    set onItemMasterFilterStateChanged(value) {
        this._setOption('onItemMasterFilterStateChanged', value);
    }
    get onItemSelectionChanged() {
        return this._getOption('onItemSelectionChanged');
    }
    set onItemSelectionChanged(value) {
        this._setOption('onItemSelectionChanged', value);
    }
    get onItemVisualInteractivity() {
        return this._getOption('onItemVisualInteractivity');
    }
    set onItemVisualInteractivity(value) {
        this._setOption('onItemVisualInteractivity', value);
    }
    get onItemWidgetCreated() {
        return this._getOption('onItemWidgetCreated');
    }
    set onItemWidgetCreated(value) {
        this._setOption('onItemWidgetCreated', value);
    }
    get onItemWidgetOptionsPrepared() {
        return this._getOption('onItemWidgetOptionsPrepared');
    }
    set onItemWidgetOptionsPrepared(value) {
        this._setOption('onItemWidgetOptionsPrepared', value);
    }
    get onItemWidgetUpdated() {
        return this._getOption('onItemWidgetUpdated');
    }
    set onItemWidgetUpdated(value) {
        this._setOption('onItemWidgetUpdated', value);
    }
    get onItemWidgetUpdating() {
        return this._getOption('onItemWidgetUpdating');
    }
    set onItemWidgetUpdating(value) {
        this._setOption('onItemWidgetUpdating', value);
    }
    get onSelectedTabPageChanged() {
        return this._getOption('onSelectedTabPageChanged');
    }
    set onSelectedTabPageChanged(value) {
        this._setOption('onSelectedTabPageChanged', value);
    }
    get _optionPath() {
        return 'viewerApi';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoViewerApiComponent.ɵfac = function DxoViewerApiComponent_Factory(t) { return new (t || DxoViewerApiComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoViewerApiComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoViewerApiComponent, selectors: [["dxo-viewer-api"]], inputs: { onDashboardTitleToolbarUpdated: "onDashboardTitleToolbarUpdated", onItemActionAvailabilityChanged: "onItemActionAvailabilityChanged", onItemCaptionToolbarUpdated: "onItemCaptionToolbarUpdated", onItemClick: "onItemClick", onItemDrillDownStateChanged: "onItemDrillDownStateChanged", onItemElementCustomColor: "onItemElementCustomColor", onItemMasterFilterStateChanged: "onItemMasterFilterStateChanged", onItemSelectionChanged: "onItemSelectionChanged", onItemVisualInteractivity: "onItemVisualInteractivity", onItemWidgetCreated: "onItemWidgetCreated", onItemWidgetOptionsPrepared: "onItemWidgetOptionsPrepared", onItemWidgetUpdated: "onItemWidgetUpdated", onItemWidgetUpdating: "onItemWidgetUpdating", onSelectedTabPageChanged: "onSelectedTabPageChanged" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoViewerApiComponent_Template(rf, ctx) { }, styles: [""] });
DxoViewerApiComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onDashboardTitleToolbarUpdated", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemActionAvailabilityChanged", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemCaptionToolbarUpdated", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemClick", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemDrillDownStateChanged", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemElementCustomColor", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemMasterFilterStateChanged", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemSelectionChanged", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemVisualInteractivity", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemWidgetCreated", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemWidgetOptionsPrepared", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemWidgetUpdated", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onItemWidgetUpdating", null);
__decorate([
    Input(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function])
], DxoViewerApiComponent.prototype, "onSelectedTabPageChanged", null);
DxoViewerApiComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoViewerApiComponent);
let DxoViewerApiModule = class DxoViewerApiModule {
};
DxoViewerApiModule.ɵfac = function DxoViewerApiModule_Factory(t) { return new (t || DxoViewerApiModule)(); };
DxoViewerApiModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoViewerApiModule });
DxoViewerApiModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

/* tslint:disable:max-line-length */
class DxoIDashboardDataSourceWizardSettings extends NestedOption {
    get enableJsonDataSource() {
        return this._getOption('enableJsonDataSource');
    }
    set enableJsonDataSource(value) {
        this._setOption('enableJsonDataSource', value);
    }
    get enableOlapDataSource() {
        return this._getOption('enableOlapDataSource');
    }
    set enableOlapDataSource(value) {
        this._setOption('enableOlapDataSource', value);
    }
    get enableSqlDataSource() {
        return this._getOption('enableSqlDataSource');
    }
    set enableSqlDataSource(value) {
        this._setOption('enableSqlDataSource', value);
    }
}

/* tslint:disable:max-line-length */
let DxoWizardSettingsComponent = class DxoWizardSettingsComponent extends DxoIDashboardDataSourceWizardSettings {
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    get _optionPath() {
        return 'wizardSettings';
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
};
DxoWizardSettingsComponent.ɵfac = function DxoWizardSettingsComponent_Factory(t) { return new (t || DxoWizardSettingsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 5), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NestedOptionHost, 1)); };
DxoWizardSettingsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DxoWizardSettingsComponent, selectors: [["dxo-wizard-settings"]], inputs: { enableJsonDataSource: "enableJsonDataSource", enableOlapDataSource: "enableOlapDataSource", enableSqlDataSource: "enableSqlDataSource" }, features: [ɵngcc0.ɵɵProvidersFeature([NestedOptionHost]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function DxoWizardSettingsComponent_Template(rf, ctx) { }, styles: [""] });
DxoWizardSettingsComponent.ctorParameters = () => [
    { type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }] },
    { type: NestedOptionHost, decorators: [{ type: Host }] }
];
DxoWizardSettingsComponent = __decorate([ __param(0, SkipSelf()), __param(0, Host()),
    __param(1, Host()),
    __metadata("design:paramtypes", [NestedOptionHost,
        NestedOptionHost])
], DxoWizardSettingsComponent);
let DxoWizardSettingsModule = class DxoWizardSettingsModule {
};
DxoWizardSettingsModule.ɵfac = function DxoWizardSettingsModule_Factory(t) { return new (t || DxoWizardSettingsModule)(); };
DxoWizardSettingsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DxoWizardSettingsModule });
DxoWizardSettingsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoAjaxRemoteServiceComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-ajax-remote-service',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { beforeSend: [{
            type: Input
        }], complete: [{
            type: Input
        }], headers: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoAjaxRemoteServiceModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoAjaxRemoteServiceComponent
                ],
                exports: [
                    DxoAjaxRemoteServiceComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoAjaxRemoteServiceModule, { declarations: [DxoAjaxRemoteServiceComponent], exports: [DxoAjaxRemoteServiceComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoDashboardExportComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-dashboard-export',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { allowExportDashboard: [{
            type: Input
        }], allowExportDashboardItems: [{
            type: Input
        }], onExportDialogHidden: [{
            type: Input
        }], onExportDialogShowing: [{
            type: Input
        }], onExportDialogShown: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoDashboardExportModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoDashboardExportComponent
                ],
                exports: [
                    DxoDashboardExportComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoDashboardExportModule, { declarations: [DxoDashboardExportComponent], exports: [DxoDashboardExportComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoDashboardParameterDialogComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-dashboard-parameter-dialog',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { onDynamicLookUpValuesLoaded: [{
            type: Input
        }], onHidden: [{
            type: Input
        }], onShowing: [{
            type: Input
        }], onShown: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoDashboardParameterDialogModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoDashboardParameterDialogComponent
                ],
                exports: [
                    DxoDashboardParameterDialogComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoDashboardParameterDialogModule, { declarations: [DxoDashboardParameterDialogComponent], exports: [DxoDashboardParameterDialogComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoDataInspectorComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-data-inspector',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { allowInspectAggregatedData: [{
            type: Input
        }], allowInspectRawData: [{
            type: Input
        }], onDialogHidden: [{
            type: Input
        }], onDialogShowing: [{
            type: Input
        }], onDialogShown: [{
            type: Input
        }], onGridContentReady: [{
            type: Input
        }], onGridInitialized: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoDataInspectorModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoDataInspectorComponent
                ],
                exports: [
                    DxoDataInspectorComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoDataInspectorModule, { declarations: [DxoDataInspectorComponent], exports: [DxoDataInspectorComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoDataRequestOptionsComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-data-request-options',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { itemDataLoadingMode: [{
            type: Input
        }], itemDataRequestMode: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoDataRequestOptionsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoDataRequestOptionsComponent
                ],
                exports: [
                    DxoDataRequestOptionsComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoDataRequestOptionsModule, { declarations: [DxoDataRequestOptionsComponent], exports: [DxoDataRequestOptionsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoDataSourceWizardComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-data-source-wizard',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { allowCreateNewJsonConnection: [{
            type: Input
        }], enableCustomSql: [{
            type: Input
        }], onCustomizeDataSourceWizard: [{
            type: Input
        }], wizardSettings: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoDataSourceWizardModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoDataSourceWizardComponent
                ],
                exports: [
                    DxoDataSourceWizardComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoDataSourceWizardModule, { declarations: [DxoDataSourceWizardComponent], exports: [DxoDataSourceWizardComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoExtensionsComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-extensions',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { dashboardExport: [{
            type: Input
        }], dashboardParameterDialog: [{
            type: Input
        }], dataInspector: [{
            type: Input
        }], dataSourceWizard: [{
            type: Input
        }], itemBindingPanel: [{
            type: Input
        }], itemOptionsPanel: [{
            type: Input
        }], mobileLayout: [{
            type: Input
        }], viewerApi: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoExtensionsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoExtensionsComponent
                ],
                exports: [
                    DxoExtensionsComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoExtensionsModule, { declarations: [DxoExtensionsComponent], exports: [DxoExtensionsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoItemBindingPanelComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-item-binding-panel',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { onCustomizeDataItemContainerSections: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoItemBindingPanelModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoItemBindingPanelComponent
                ],
                exports: [
                    DxoItemBindingPanelComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoItemBindingPanelModule, { declarations: [DxoItemBindingPanelComponent], exports: [DxoItemBindingPanelComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoItemOptionsPanelComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-item-options-panel',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { onCustomizeSections: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoItemOptionsPanelModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoItemOptionsPanelComponent
                ],
                exports: [
                    DxoItemOptionsPanelComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoItemOptionsPanelModule, { declarations: [DxoItemOptionsPanelComponent], exports: [DxoItemOptionsPanelComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoMobileLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-mobile-layout',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { mobileLayoutEnabled: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoMobileLayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoMobileLayoutComponent
                ],
                exports: [
                    DxoMobileLayoutComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoMobileLayoutModule, { declarations: [DxoMobileLayoutComponent], exports: [DxoMobileLayoutComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoViewerApiComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-viewer-api',
                template: '',
                providers: [NestedOptionHost],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, { onDashboardTitleToolbarUpdated: [{
            type: Input
        }], onItemActionAvailabilityChanged: [{
            type: Input
        }], onItemCaptionToolbarUpdated: [{
            type: Input
        }], onItemClick: [{
            type: Input
        }], onItemDrillDownStateChanged: [{
            type: Input
        }], onItemElementCustomColor: [{
            type: Input
        }], onItemMasterFilterStateChanged: [{
            type: Input
        }], onItemSelectionChanged: [{
            type: Input
        }], onItemVisualInteractivity: [{
            type: Input
        }], onItemWidgetCreated: [{
            type: Input
        }], onItemWidgetOptionsPrepared: [{
            type: Input
        }], onItemWidgetUpdated: [{
            type: Input
        }], onItemWidgetUpdating: [{
            type: Input
        }], onSelectedTabPageChanged: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoViewerApiModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoViewerApiComponent
                ],
                exports: [
                    DxoViewerApiComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoViewerApiModule, { declarations: [DxoViewerApiComponent], exports: [DxoViewerApiComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoWizardSettingsComponent, [{
        type: Component,
        args: [{
                selector: 'dxo-wizard-settings',
                template: '',
                providers: [NestedOptionHost],
                inputs: [
                    'enableJsonDataSource',
                    'enableOlapDataSource',
                    'enableSqlDataSource'
                ],
                styles: ['']
            }]
    }], function () { return [{ type: ɵngcc1.NestedOptionHost, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }] }, { type: ɵngcc1.NestedOptionHost, decorators: [{
                type: Host
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DxoWizardSettingsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DxoWizardSettingsComponent
                ],
                exports: [
                    DxoWizardSettingsComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DxoWizardSettingsModule, { declarations: [DxoWizardSettingsComponent], exports: [DxoWizardSettingsComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DxoAjaxRemoteServiceComponent, DxoAjaxRemoteServiceModule, DxoDashboardExportComponent, DxoDashboardExportModule, DxoDashboardParameterDialogComponent, DxoDashboardParameterDialogModule, DxoDataInspectorComponent, DxoDataInspectorModule, DxoDataRequestOptionsComponent, DxoDataRequestOptionsModule, DxoDataSourceWizardComponent, DxoDataSourceWizardModule, DxoExtensionsComponent, DxoExtensionsModule, DxoItemBindingPanelComponent, DxoItemBindingPanelModule, DxoItemOptionsPanelComponent, DxoItemOptionsPanelModule, DxoMobileLayoutComponent, DxoMobileLayoutModule, DxoViewerApiComponent, DxoViewerApiModule, DxoWizardSettingsComponent, DxoWizardSettingsModule, DxoIDashboardDataSourceWizardSettings as ɵa };

